import ActivityList from '@/views/activity/activity-list.vue';
import ActivityDetail from '@/views/activity/activity-detail.vue';
import ActivityGoodsList from '@/views/activity/activity-goods-list.vue';
export default [
    {
        path: '/activity/activity-list',
        component: ActivityList,
        name: 'activityList'
    },
    {
        path: '/activity/activity-detail',
        component: ActivityDetail,
        name: 'activityDetail'
    },
    {
        path: '/activity/activity-goods-list.vue',
        component: ActivityGoodsList,
        name: 'activityGoodsList'
    },
]